import { createFileRoute } from "@tanstack/react-router";

import ModelRoutingAdmin from "@/components/ModelRoutingAdmin";

// A passthrough like its neighbours: the console component owns everything, and
// `admin/route.tsx` owns the shell and the gate. The page's own routes enforce
// `manage_model_routing` server-side.
export const Route = createFileRoute("/admin/model-routing")({
  component: ModelRoutingAdmin,
});
